module.exports = __webpack_public_path__ + "static/media/youtube.007fe43b.svg";